import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconPlusInCircleWhiteOnBlack({
	size = "100",
	...props
}: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="none" fillRule="evenodd" transform="translate(1 1)">
				<circle cx={11} cy={11} r={11} fill="#000" />
				<path
					fill="#FFF"
					fillRule="nonzero"
					d="M12.76 5.949V7.92q0 .563.211.774.212.212.775.212h1.97q.88 0 .88.88v2.147q0 .88-.88.88h-1.97q-.564 0-.775.193-.21.194-.211.792v1.972q0 .88-.88.88H9.733q-.88 0-.88-.88v-1.972q0-.599-.194-.792-.193-.193-.792-.193H5.896q-.88 0-.88-.88V9.715q0-.81.88-.81h1.971q.6 0 .792-.21.195-.212.194-.775V5.949q0-.88.88-.88h2.147q.88 0 .88.88"
				/>
			</g>
		</svg>
	);
}
